import React from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SubHeader } from 'cstar-react-primitives';

import { loginUrl } from '../../user/utils';
import { loyaltyMessages } from './loyaltyMessages';
import { useUsers } from '../../user/UserContext';
import { useLoyalty } from "./LoyaltyProvider";
import { useFormatMessage } from '../../intl/intlHooks';
import { toQueryString } from '../../utils/sharedFunctions';
import { lineItemMultiplierExists } from '../../lineItem/lineItemSelectors';

export const PointsNotice = ({ multiplierExists }) => {
    const formatMessage = useFormatMessage();
    const location = useLocation();
    const { userData } = useUsers();
    const { name, image } = useLoyalty();
    const isLoggedIn = Object.entries(userData).length > 0;
    const initUrl = `${loginUrl}${toQueryString({ redirect_url: location.pathname })}`;
    const signUpLink = <a href={initUrl} key={uuid()}>{formatMessage(loyaltyMessages.signUpLink)}</a>;
    const logInLink = <a href={initUrl} key={uuid()}>{formatMessage(loyaltyMessages.logInLink)}</a>;
    const markupWithLanguageToUse = isLoggedIn ? (
        <p className="overflow-hidden first-bit-paragraph">
            <strong>{formatMessage(loyaltyMessages.loggedInLanguageFirstBit)}</strong>
            <br />
            {formatMessage(loyaltyMessages.eitherStatusLanguageSecondBit, { strong: msg => <span style={{ fontWeight: 'bold' }}>{msg}</span> } )}
        </p>
    ) : (
        <React.Fragment>
            <p className="overflow-hidden first-bit-paragraph">
                {formatMessage(loyaltyMessages.notLoggedInLanguageFirstBit, {
                    signUpLink,
                    logInLink,
                    name
                })}
            </p>
            <p className="overflow-hidden second-bit-paragraph">
                {formatMessage(loyaltyMessages.eitherStatusLanguageSecondBit, { strong: msg => <span style={{ fontWeight: 'bold' }}>{msg}</span> } )}
            </p>
        </React.Fragment>
    );

    return multiplierExists && (
        <div className="points-notice-container">
            <legend>
                <SubHeader heading={formatMessage(loyaltyMessages.header)} />
            </legend>
            {image && (
                <img
                    src={image}
                    alt="Loyalty Card"
                />
            )}
            {markupWithLanguageToUse}
        </div>
    );
};

PointsNotice.propTypes = {
    multiplierExists: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    multiplierExists: lineItemMultiplierExists(state)
});

export default connect(mapStateToProps)(PointsNotice);
